<template>
    <AuthenticatedLayout>
        <Card>
            <template #title>
                MAC Indicator - {{pairName}} at {{timeframe}}
            </template>
            <template #content>
                <div class="w-full" id="chart_container">
                    <trading-vue
                        ref="chart"
                        id="chart_container"
                        type="candles"
                        :width="2000"
                        color-back="#ffffff"
                        color-grid="#eee"
                        color-text="#333"
                        :timezone="3"
                        titleTxt="MAC Indicator"
                        :data="data_chart"
                        :chart-config="{DEFAULT_LEN: 400}"
                    ></trading-vue>
                </div>
                <div class="mt-4">
                    <h2>Время расчёта индикатора (первые 10 раз)</h2>
                    <div v-for="time in times">{{time}}</div>
                </div>
            </template>
        </Card>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { TradingVue, DataCube } from "trading-vue-js";
import helperMethods from "@/helpers";
import Card from 'primevue/card'
export default {
    props:{
        indicatorData: Object,
        candles: Array,
        times: Array,
        pairName: String,
        timeframe: String,
    },
    components:{
        TradingVue, AuthenticatedLayout, Card
    },
    data(){
        return {

        }
    },
    computed:{
        data_chart(){
            return new DataCube({
                ohlcv: this.ohlcvFromCandles(this.candles),
                onchart:[
                    {
                        name: "MA",
                        type: "Spline",
                        data: this.ma_data,
                        color: "#76ce52",

                    },
                    {
                        name: "FMA",
                        type: "Spline",
                        data: this.fma_data,
                        colors: "#d05a5a",
                    },
                ]
            })
        },
        ma_data(){
            return Object.entries(this.indicatorData).map(([key, indicator])=> {
                return [
                    parseInt(key), parseFloat(indicator.mac_ma)
                ]
            })
        },
        fma_data(){
            return Object.entries(this.indicatorData).map(([key, indicator])=> {
                return [
                    parseInt(key), parseFloat(indicator.mac_fma)
                ]
            })
        },
    },
    methods: {
        ...helperMethods,
    }
}
</script>
